import { useState } from "react";
import constraintStyles from "../../styles/constraint.module.css";
import labels from "../../utils/labels";
import EmployeeListItem from "./EmployeeListItem";
import { useAppSelector } from "../../store/hooks";
import Checkbox from "../UI/input/Checkbox";
import {
  filterBySearchTerm,
  isConstraintActive,
  sortByName,
} from "../../utils/arrayUtils";
import InputTextField from "../UI/input/InputTextField";
import ConstraintExplainer from "./ConstraintExplainer";

const EmployeeConstraintTab = () => {
  const employees = useAppSelector((state) => state.constraintSlice.employees);
  const [showActiveOnly, setShowActiveOnly] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const visibleEmployees = sortByName(
    filterBySearchTerm(
      showActiveOnly
        ? employees.filter((e) =>
            e.constraints.some((c) =>
              isConstraintActive(c.startDate, c.endDate),
            ),
          )
        : employees,
      (e) => [e.name, e.initials],
      searchTerm,
    ),
    (e) => e.name,
  );

  return (
    <>
      <ConstraintExplainer />
      {employees.length > 0 && (
        <div className={constraintStyles.header}>
          <InputTextField
            id="employee-constraint-search"
            label={labels.searchEmployeeConstraint}
            placeholder={labels.typeName}
            direction="COLUMN"
            fieldWidth="300px"
            onInputChange={setSearchTerm}
            value={searchTerm}
          />
          <Checkbox
            checked={showActiveOnly}
            onChange={setShowActiveOnly}
            label={labels.showActiveConstraintsOnly}
          />
        </div>
      )}
      <div>
        {visibleEmployees.map((employee) => (
          <EmployeeListItem
            key={employee.employeeRef}
            employee={employee}
            showActiveOnly={showActiveOnly}
          />
        ))}
      </div>
    </>
  );
};

export default EmployeeConstraintTab;
